import React from 'react'
import Header from './components/Header.js'
import Main from './components/Main.js'
import Footer from './components/Footer.js'
import './style.css'
import { Routes, Route, BrowserRouter} from 'react-router'
import ScrollToAnchor from './components/ScrollToHashElement.jsx'
import Notice from './components/Notice.jsx'
import Criterion from './components/Criterion.jsx'

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/~naka-hp" element={
                <Main />
          } />
          <Route path="/~naka-hp/notice" element={
            <Notice />
          } />
          <Route path="/~naka-hp/criterion" element={
            <Criterion />
          } />
        </Routes>
        <Footer />
        <ScrollToAnchor />
      </BrowserRouter>
    )
  }
}

export default App
